import GrainIcon from '@material-ui/icons/Grain';
import ReorderIcon from '@material-ui/icons/Reorder';
import { withRouter } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withGS from '../../core/withGShoc';
import { globalStyles } from '../../core/style/gstheme';

const styles = Object.assign({}, globalStyles);

class MemberOfCollection extends Component {

  handleClick() {
    this.props.history.push(this.props.link);
  }

  render() {

    const { classes, data, conceptIRI, id, defaultLang } = this.props;
    const memberProp = this.props.data.type.includes("OrderedCollection") ? "memberList" : "member";
    if (!data[memberProp] || (data[memberProp] && !data[memberProp].includes(conceptIRI))) return <span />;

    return (
      <Chip
        data-test="collection-link"
        style={{ margin: 5 }}
        onClick={() => this.handleClick()}
        variant="outlined"
        avatar={<Avatar className={classes.collectionAvatar}>
          {memberProp === "memberList" ?
            <ReorderIcon fontSize="small" />
            :
            <GrainIcon fontSize="small" />
          }
        </Avatar>}
        label={
          <span data-test={"link-" + id}>
            {(
              data.title ?
                (data.title[defaultLang] ? data.title[defaultLang] : data.id)
                :
                data.id
            ) + (data.type.includes("OrderedCollection") ? (" (" + (data.memberList.indexOf(conceptIRI) + 1) + ")") : "")}
          </span>}
      />
    );
  }
}

MemberOfCollection.propTypes = {
  link: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  conceptIRI: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired
};

export default withRouter(withStyles(styles)(withGS(MemberOfCollection)));